const defaultFileName = 'Untitled Canvas'
const defaultFileNameTooltip = 'Rename'
const defaultGroupName = 'Unnamed'
const defaultOperatorName = 'AND'
const defaultLayoutName = 'square'
const defaultTermName = ''
const paletteGroupName = 'Group'
const paletteTermName = 'Term'
const nestedLayoutName = 'Nested'
const inlineLayoutName = 'Inline'
const treeLayoutName = 'Tree (non-editable)'
const availableLayouts = [
  nestedLayoutName,
  inlineLayoutName,
  treeLayoutName
]
const noUrlMessage = 'Your URL will appear here'
const noBooleanStringMessage = 'Your Query String will appear here'

const defaultGroupAttributes = {
  text: defaultGroupName,
  color: '#CCCCCC',
  isGroup: true,
  category: 'OfGroups',
  operator: 'OR',
  layout: defaultLayoutName,
  childrenPrefixOperatorVisible: false,
  ordering: 1,
  isInPalette: false,
  isSubGraphExpanded: true,
  isIncludedInQuery: true,
  backgroundAlt: false,
  isNegative: false
}

const paletteGroupAttributes = {
  ...defaultGroupAttributes,
  text: paletteGroupName,
  isInPalette: true
}

const defaultNodeAttributes = {
  color: '#33D3E5',
  isIncludedInQuery: true,
  ordering: 0,
  isNegative: false
}

export const baseQueryAttributes = {
  name: null,
  _id: null,
  defaultOperator: defaultOperatorName,
  isPublic: false
}

export const fileExtension = '.tds'

export const bgPrimary = '#F9FCFF'
export const grey500 = '#DBE0E6'
export const minorGridLines = '#DEDEDE'
export const majorGridLines = '#B9B9B9'

export const resultsSectionSourceCarouselWidth = 90

export const red500 = '#ee2b2a'
export const lightBlue50 = '#daf3fe'
export const lightBlue500 = '#1397f1'
export const blueGrey800 = '#37474f'
export const blueGrey600 = '#546e7A'
export const blueGrey400 = '#657D8A'
export const blueGrey300 = '#768E9B'
export const blueGrey200 = '#879FAC'
export const blueGrey100 = '#98B0BD'
export const blueGrey50 = '#eceff1'
export const grey800 = '#424242'
export const grey700 = '#616161'
export const grey400 = '#bdbdbd'
export const grey300 = '#e0e0e0'
export const grey200 = '#eeeeee'
export const grey100 = '#f5f5f5'
export const grey50 = '#fafafa'
export const orangeA100 = '#ffd180'
export const orange500 = '#ff8a0e'
export const amber900 = '#ff6f00'

export const howToUseUrl = 'https://www.2dsearch.com/help'
export const aboutUrl = 'https://www.2dsearch.com'
export const requestDemoUrl = 'https://www.2dsearch.com/request-demo'
export const faqUrl = 'https://www.2dsearch.com/faq'
export const helpMeChooseUrl = 'https://www.2dsearch.com/help-me-choose'
export const blogAIGenUrl = 'https://www.2dsearch.com/news/2024/1/22/new-year-new-release'
export const editSearchVideoUrl = 'https://www.youtube.com/watch?v=5ofHonrvwnI&feature=youtu.be'
export const buildOnCanvasVideoUrl = 'https://www.youtube.com/watch?v=tJ3fBRvszhQ&feature=youtu.be'

export const spacingVerticalForTopLevel = 4
export const offsetGroupX = 8
export const offsetGroupY = 50
export const offsetNodeAboveDiagram = 50

export const objectTypes = { 'canvas': 1, 'group': 2, 'node': 3 }

export const snapOptions = [
  {name: 'Off', size: 0},
  {name: 'Large', size: 50},
  {name: 'Small', size: 10}
]
export const snapOff = snapOptions[0]

export const layoutGroupSpacing = 0 // Reduced from 12 to zero as transparent hit count takes up space on group like duplicate badge on node
export const layoutNodeSpacingAdjustmentForBadge = -10
export const layoutHorizontalFudge = -5

const MAX_CHARS_STRATEGY_TITLE_HALF = 15

export {
  availableLayouts,
  nestedLayoutName,
  inlineLayoutName,
  treeLayoutName,
  defaultGroupAttributes,
  paletteGroupAttributes,
  defaultFileName,
  defaultFileNameTooltip,
  defaultGroupName,
  defaultOperatorName,
  defaultLayoutName,
  defaultTermName,
  noUrlMessage,
  noBooleanStringMessage,
  paletteGroupName,
  paletteTermName,
  defaultNodeAttributes,
  MAX_CHARS_STRATEGY_TITLE_HALF
}



// WEBPACK FOOTER //
// ./src/utils/constants.js